import $ from 'jquery';

/**
 * @param $menu
 * @param config
 * @constructor
 */
var Menu = function ($menu, config) {
    this.menu = $menu;
    this.listitemsWithChildren = [];
    this.findListitemsWithChildren();
    this.addListener();
    this.desktop = config.desktop || 768;
    this.activeClass = 'navigation__list-wrap--show';
    this.activeLinkClass = 'navigation__link--active';
    this.activeNavigationIconClass = 'navigation__toggle-icon--open';
    this.activeClassSelector = '.' + this.activeClass;
};

/**
 * Find all pages with subpages
 * @param $ul
 */
Menu.prototype.findListitemsWithChildren = function ($ul) {
    var menu = this;
    $ul = $ul || this.menu;
    $.each($ul.children(), function (index, li) {
        var $subUl = $(li).find('ul').first();
        if ($subUl.length > 0) {
            menu.listitemsWithChildren.push($(li));
            menu.findListitemsWithChildren($subUl);
        }
    });
};

/**
 * Add event listeners
 */
Menu.prototype.addListener = function () {
    var menu = this;
    menu.listitemsWithChildren.forEach(function ($li) {
        $li.find('.navigation__toggle-icon').first().on('click', menu.toggleSublist.bind(menu));
    });
};

/**
 * Mobile event
 * Toggles a sublist
 * @param e
 */
Menu.prototype.toggleSublist = function (e) {
    var menu = this;
    if ($(window).width() >= this.desktop) {
        return;
    }
    var $ul = $(e.target).siblings('div');
    if ($ul.length < 1) {
        return;
    }

    var $target = $(e.target);

    if ($ul.hasClass(menu.activeClass)) {
        e.preventDefault();
        $target.removeClass(this.activeNavigationIconClass);
        $target.siblings('a').removeClass(this.activeLinkClass);
        $ul.removeClass(menu.activeClass);
    } else {
        e.preventDefault();
        menu.closeOpenedLists($ul);
        $target.addClass(this.activeNavigationIconClass);
        $target.siblings('a').addClass(this.activeLinkClass);
        $ul.addClass(menu.activeClass);
    }
};

/**
 * Mobile event
 * Closes all opened sublists at the current level
 * @param $ul
 */
Menu.prototype.closeOpenedLists = function ($ul) {
    var menu = this;
    var $activeListsAtCurrentLevel = $ul.parent().closest('ul').find(menu.activeClassSelector);
    $.each($activeListsAtCurrentLevel, function () {
        if ($(this).hasClass(menu.activeClass)) {
            $(this).removeClass(menu.activeClass);
            $(this).siblings('.navigation__toggle-icon').removeClass(menu.activeNavigationIconClass);
            $(this).siblings('a').removeClass(menu.activeLinkClass);
        }
    });
};

// Add as jquery plugin
$.fn.menu = function (config) {
    return new Menu(this, config);
};
